<template>
  <section class="work-flow">
    <div class="work-flow__container default-content">
      <h2 class="section-title">{{locales.pages && locales.pages.how_it_works}}</h2>
      <div class="work-flow__tabs">
        <a class="work-flow__tabs-item" :class="termValue === 0 ? 'work-flow__tabs-item--active' : ''" href="#" @click.prevent='changeTermValue(0)'>{{locales.pages && locales.pages.long_term_rent}}</a>
        <a class="work-flow__tabs-item" :class="termValue === 1 ? 'work-flow__tabs-item--active' : ''" href="#" @click.prevent='changeTermValue(1)'>{{locales.pages && locales.pages.short_term_booking}}</a>
      </div>
      <template v-if='termValue === 0'>
        <div class="work-flow__list">
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-search"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.long_term_1_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.long_term_1_content_lang[lang]"></p>
          </div>
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-upload"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.long_term_2_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.long_term_2_content_lang[lang]"></p>
          </div>
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-approved"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.long_term_3_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.long_term_3_content_lang[lang]"></p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="work-flow__list">
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-search"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.short_term_1_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.short_term_1_content_lang[lang]"></p>
          </div>
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-upload"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.short_term_2_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.short_term_2_content_lang[lang]"></p>
          </div>
          <div class="work-flow__list-item">
            <div class="work-flow__list-image-holder">
              <i class="icon-approved"></i>
            </div>
            <h3 class="work-flow__list-title">{{page.short_term_3_title_lang[lang]}}</h3>
            <p class="work-flow__list-text" v-html="page.short_term_3_content_lang[lang]"></p>
          </div>
        </div>
      </template>
      <a :href="link" class="theme-btn theme-btn--tertiary">
        {{locales.pages && locales.pages.create_tenant_account}}
        <i class="icon-go-right"></i>
      </a>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import _ from "lodash";
  import $ from "jquery";
  export default {
    props: {
      page: {
        default: {},
        type: Object
      },
      lang: {
        default: 'nl',
        type: String
      },
      link: {
        default: '#',
        type: String
      }
    },
    computed: {
      ...mapGetters(["locales"]),
      termValue: function () {
        return this.$store.state.term.termValue;
      },
    },
    methods: {
      changeTermValue(value) {
        this.$store.commit('CHANGE_TERM_VALUE', value);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/WorkFlow.vue